import { GridItem } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import {
  employmentInsuranceTypes,
  flagTypes,
  healthInsuranceTypes,
  mutualAidNotebookTypes,
  pensionInsuranceTypes,
} from '../../../../constants/code';
import { useFormItems } from '../../../../hooks/formItems';
import InformationItems, { ItemCommonProps } from './Information';
import { UserInfoState } from './UserInfoAccordion';

/**
 * 保険・共済情報
 */
type InsuranceAndMutualAidState = Pick<UserInfoState, 'workerReference'>;

/**
 * 保険・共済情報
 * @param props -
 * @returns
 */
const InsuranceAndMutualAidInformation: React.FunctionComponent<
  ItemCommonProps
> = (props) => {
  const form = useFormContext<InsuranceAndMutualAidState>();
  const { FormInput, FormRadioGroup, FormSelect } =
    useFormItems<InsuranceAndMutualAidState>(form);

  return (
    <InformationItems name="保険・共済" panelIndex={4}>
      <GridItem margin={2}>
        <FormRadioGroup<number>
          label="健康保険種類"
          mode={props.mode}
          name="workerReference.healthInsuranceType"
          options={Object.entries(healthInsuranceTypes).map(([k, v]) => ({
            value: parseInt(k),
            valueToDisplay: v,
          }))}
          radioGroupProps={{ defaultValue: 2 }}
          valueConverter={parseInt}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="健康保険番号"
          mode={props.mode}
          name="workerReference.healthInsuranceNo"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormRadioGroup<number>
          label="年金保険種類"
          mode={props.mode}
          name="workerReference.pensionInsuranceType"
          options={Object.entries(pensionInsuranceTypes).map(([k, v]) => ({
            value: parseInt(k),
            valueToDisplay: v,
          }))}
          radioGroupProps={{ defaultValue: 2 }}
          valueConverter={parseInt}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="年金保険番号"
          mode={props.mode}
          name="workerReference.pensionInsuranceNo"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormRadioGroup<number>
          label="雇用保険種類"
          mode={props.mode}
          name="workerReference.employmentInsuranceType"
          options={Object.entries(employmentInsuranceTypes).map(([k, v]) => ({
            value: parseInt(k),
            valueToDisplay: v,
          }))}
          radioGroupProps={{ defaultValue: 3 }}
          valueConverter={parseInt}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="雇用保険番号"
          mode={props.mode}
          name="workerReference.employmentInsuranceNo"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormSelect<boolean>
          label="建設業退職金共済制度有無"
          mode={props.mode}
          name="workerReference.ciRamas"
          options={Object.entries(flagTypes).map(([k, v]) => ({
            value: k === 'true',
            valueToDisplay: v,
          }))}
          valueConverter={(value) =>
            value === 'true' ? true : value === 'false' ? false : null
          }
        />
      </GridItem>
      <GridItem margin={2}>
        <FormSelect<boolean>
          label="中小企業退職金共済制度有無"
          mode={props.mode}
          name="workerReference.smbRamas"
          options={Object.entries(flagTypes).map(([k, v]) => ({
            value: k === 'true',
            valueToDisplay: v,
          }))}
          valueConverter={(value) =>
            value === 'true' ? true : value === 'false' ? false : null
          }
        />
      </GridItem>
      <GridItem margin={2}>
        <FormRadioGroup<number>
          label="共済手帳有無"
          mode={props.mode}
          name="workerReference.ownedMutualAidNotebook"
          options={Object.entries(mutualAidNotebookTypes).map(([k, v]) => ({
            value: parseInt(k),
            valueToDisplay: v,
          }))}
          radioGroupProps={{ defaultValue: 4 }}
          valueConverter={parseInt}
        />
      </GridItem>
    </InformationItems>
  );
};

export default InsuranceAndMutualAidInformation;
